import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
 import axiosInstance, { adminurl, weburl } from "../../axiosInstance";
import Header from "../components/Header";
import Footer from "../components/Footer";
import LoadingScreen from "../components/LoadingScreen";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Select from "react-select";

const SignupUserType = () => {


    const {
      Headers,
      isHeader, 
    } = useBlogContext();


  const { id } = useParams();

 
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true); // Add loading state

  const [SubmitLoading, setSubmitLoading] = useState(false); // Add loading state
  const [data, setData] = useState([]);
    const [catData, setcatData] = useState([]);

  const [filteredCities, setFilteredCities] = useState([]);

  const [inputs, setInputs] = useState({
    type: "1",
    username: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    pincode: "",
    Gender: "1",
    DOB: "",
    address: "",
    // profile: null, // Changed to null to match file type
    // DLfile: null,
    // AadhaarFront: null,
    // AadhaarBack: null,
    // PoliceVerification: null,
    // PassPort: null,
    // Electricity: null,
    // WaterBill: null,
  });

  // //handle input change
  // const handleChange = (e) => {
  //     const { name, value, type, checked, files } = e.target;
  //     setInputs((prevData) => ({
  //         ...prevData,
  //         [name]:
  //             type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //     }));
  // };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const removeCoverage = (cityToRemove) => {
    setInputs((prev) => ({
      ...prev,
      coverage: prev.coverage.filter((c) => c !== cityToRemove),
    }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files[0];
    } else {
      newValue = value;
    }

    // Capitalize text for the 'username' field
    if (name === "username") {
      newValue = capitalizeEachWord(newValue);
    }
    // Capitalize text for the 'username' field

    if (name === "coverage") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.coverage) ? inputs.coverage : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          coverage: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
    

 // Capitalize text for the 'username' field
 if (name === "state") {
  const selectedState = data.find((state) => state._id === newValue);
  if (selectedState) {
    setFilteredCities(selectedState.cities);
    setInputs((prevData) => ({
      ...prevData,
      statename: selectedState.name,
      city: "",
    }));
  }
  console.log("selectedState", selectedState, newValue, data);
}

    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const [showPassword, setShowPassword] = useState(false);

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async () => {
 
    if(!inputs.type){
      toast.error("please select user type");
         return;
    }

    if(inputs.type === "4" && !inputs.empType){
      toast.error("please select empployee type");
         return;
    }

    setSubmitLoading(false);
    console.log(inputs);

    const fields = [
      { name: "username", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "password", message: "Please enter password" },
      { name: "confirm_password", message: "Please enter confirm password" },
      { name: "state", message: "Please enter State" },
      { name: "city", message: "Please enter State" },
      { name: "pincode", message: "Please enter pincode" },
      { name: "coverage", message: "Please Select Coverage Area" },
      
      // Fields below are conditionally required based on inputs.type
      ...(inputs.type !== "3"
        ? [
            { name: "Gender", message: "Please enter Gender" },
            { name: "DOB", message: "Please enter DOB" },
          ]
        : []),
    ];

    for (const field of fields) {
      if (!inputs[field.name]) {
        toast.error(field.message);
        setSubmitLoading(true);
        return;
      }
    }

    if (inputs.password !== inputs.confirm_password) {
      toast.error("Password does not match");
      setSubmitLoading(true);
      return;
    }

    if(form.address === '' || form.address === null){
      toast.error('Please Search location');
              setSubmitLoading(true);
       return;
    }
    // Email Validation (basic regex)
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(inputs.email)) {
      toast.error("Please enter a valid email address");
      setSubmitLoading(true);
      return;
    }

    // DOB Validation (age 18+)
    let dob = new Date(inputs.DOB);
    let today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    let m = today.getMonth() - dob.getMonth();
    
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    
    if (age < 18) {
      toast.error("You must be at least 18 years old");
      setSubmitLoading(true);
      return;
    }

    console.log("mydata", inputs);

   const  finaldata = {
        ...inputs,
     address : form.address,
longitude: form.longitude,
latitude: form.latitude
   }
    try {
      const { data } = await axiosInstance.post(
        `/signup-user-type`,
        finaldata
        //    {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //   },
        // }
      );
      const { success } = data;
      if (success) {
        toast.success("Account Created Successfully  ");
        setTimeout(() => {
          window.location.href = adminurl;
        }, 1000);
      }
    } catch (error) {
      console.error("Error On Signup:", error);
      toast.error(error.response.data.message);
      setSubmitLoading(true);

    } finally {
      setSubmitLoading(true);
    }

    setSubmitLoading(true);
  };

  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  const fetchCat = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("admin/get-home-category/"+id);
      console.log("response.data.Zones,", response.data.Zones);
      setcatData(response.data.Category ?? []);
    } catch (error) {
      toast.error('something went wrong!')
      navigate('/home');
       console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


    const buyNow = async () => { 
      try { 
  
   const  finaldata = {
   ...inputs,
   address : form.address,
longitude: form.longitude,
latitude: form.latitude,
type: catData.type,
empType: (catData.multi && catData.multi.length !== 0 && catData.logic !== 1 ) ? inputs.empType : catData.empType,
dynamicType: 
(catData.multi && catData.multi.length !== 0 && catData.logic === 1 ) ? inputs.dynamic : 
(catData.logic === 1 ? catData.title : ''),
totalAmount: catData.price,
   }
  
        console.log('mydata',finaldata);
       
     if(catData.multi && catData.multi.length !== 0 && catData.logic === 1 && !inputs.dynamic ){
         toast.error("please select user type");
         return;
     }
         if(catData.multi && catData.multi.length !== 0 && catData.logic !== 1 && !inputs.empType ){
         toast.error("please select user type");
         return;
     } 
   
    setSubmitLoading(true);
    console.log(inputs);

    const fields = [
      { name: "username", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "password", message: "Please enter password" },
      { name: "confirm_password", message: "Please enter confirm password" },
      { name: "state", message: "Please enter State" },
      { name: "city", message: "Please enter State" },
      { name: "pincode", message: "Please enter pincode" },
      { name: "coverage", message: "Please Select Coverage Area" },
      
      // Fields below are conditionally required based on inputs.type
      ...(inputs.type !== "3"
        ? [
            { name: "Gender", message: "Please enter Gender" },
            { name: "DOB", message: "Please enter DOB" },
          ]
        : []),
    ];

    for (const field of fields) {
      if (!inputs[field.name]) {
        toast.error(field.message);
        setSubmitLoading(false);
        return;
      }
    }

    if (inputs.password !== inputs.confirm_password) {
      toast.error("Password does not match");
      setSubmitLoading(false);
      return;
    }

    if(form.address === '' || form.address === null){
      toast.error('Please Search location');
              setSubmitLoading(false);
       return;
    }
    // Email Validation (basic regex)
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(inputs.email)) {
      toast.error("Please enter a valid email address");
      setSubmitLoading(false);
      return;
    }

    // DOB Validation (age 18+)
    let dob = new Date(inputs.DOB);
    let today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    let m = today.getMonth() - dob.getMonth();
    
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    
    if (age < 18) {
      toast.error("You must be at least 18 years old");
      setSubmitLoading(false);
      return;
    }

    console.log("mydata", inputs);



      setSubmitLoading(true);
  
        const { data } = await toast.promise(
          axiosInstance.post(`/create-user-by-pay`, finaldata ),
          {
            loading: "Creating user",
            success: "Create user sucesssfully!",
            error: "Failed to create ads.",
          }
        );
  
        const { success ,user } = data;
        if (success) {
       
       const options = {
                      key: Headers.keyId,
                      amount: user.price * 100,
                      currency: "INR",
                      name: "Ontech Digital",
                      description: "Ontech Digital Find Local Service Professionals Near You!",
                      image: Headers.meta_logo,
                      order_id: user.razorpay_order_id,
                      callback_url: `${weburl}user-payment-verification`,
                      // prefill: {
                      //   name: "test gupta",
                      //   email: "test@gmail.com",
                      //   contact: "1234567890",
                      // },
                      notes: {
                        address: "razorapy official",
                      },
                      theme: {
                        color: "#3399cc",
                      },
                    };
                    const razor = new window.Razorpay(options);
                    razor.open();
            
  
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setSubmitLoading(false);
      } finally {
        setSubmitLoading(false);
      }
    };
  

  useEffect(() => {
    fetchData();
    fetchCat();
  }, []);

    useEffect(() => {
     setInputs((prevData) => ({
      ...prevData,
      empType: null,
    }));
  }, [inputs.type]);


  


  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  // mym map logic 

   const mapRef = useRef(null);
  const markerRef = useRef(null);
  const geocoderRef = useRef(null);
  const autocompleteRef = useRef(null);
  const searchInputRef = useRef(null);

  const [loadingMaps, setLoadingMaps] = useState(true);
  const [placeId, setPlaceId] = useState("");
  const [form, setForm] = useState({
    address: "",
    latitude: "",
    longitude: "",
  });

  const toFixed6 = (n) => Number(n).toFixed(6);

  // --- load Google Maps script dynamically ---
//   useEffect(() => {
  
//  initMap()
//   }, []);

useEffect(() => {
  const interval = setInterval(() => {
    if (window.google && mapRef.current) {
      initMap();
      clearInterval(interval);
    }
  }, 100);
  return () => clearInterval(interval);
}, []);


  // --- init map ---
  function initMap() {
    // Fallback center: New Delhi
    const start = { lat: 28.6139, lng: 77.2090 };

    const map = new window.google.maps.Map(mapRef.current, {
      center: start,
      zoom: 13,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: true,
    });

    const marker = new window.google.maps.Marker({
      position: start,
      map,
      draggable: true,
      animation: window.google.maps.Animation.DROP,
    });

    const geocoder = new window.google.maps.Geocoder();

    // Click on map = move marker + reverse geocode
    map.addListener("click", (e) => updatePosition(e.latLng));

    // Drag marker end = reverse geocode
    marker.addListener("dragend", (e) => updatePosition(e.latLng));

    // Places Autocomplete
    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInputRef.current,
      {
        fields: ["place_id", "formatted_address", "geometry", "address_components"],
        // componentRestrictions: { country: ["in"] }, // <- uncomment to restrict to India
      }
    );
    autocomplete.bindTo("bounds", map);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        toast("No details for that selection.");
        return;
      }
      setPlaceId(place.place_id || "");
      updatePosition(place.geometry.location, place.formatted_address);
    });

    function updatePosition(latLng, presetAddress) {
      map.panTo(latLng);
      marker.setPosition(latLng);

      const lat = toFixed6(latLng.lat());
      const lng = toFixed6(latLng.lng());

      setForm((f) => ({ ...f, latitude: lat, longitude: lng }));

      if (presetAddress) {
        setForm((f) => ({ ...f, address: presetAddress }));
      } else {
        geocoder.geocode({ location: latLng }, (res, status) => {
          if (status === "OK" && res && res[0]) {
            setForm((f) => ({ ...f, address: res[0].formatted_address || "" }));
            setPlaceId((pid) => pid || res[0].place_id || "");
          } else {
            setForm((f) => ({ ...f, address: "" }));
          }
        });
      }
    }

    // Expose in refs
    markerRef.current = marker;
    geocoderRef.current = geocoder;
    autocompleteRef.current = autocomplete;
 
    setLoadingMaps(false);
  }

  function geolocate() {
    if (!navigator.geolocation) {
      toast("Geolocation not supported.");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        const latLng = new window.google.maps.LatLng(latitude, longitude);
        setPlaceId("");
        // Reuse same flow as init
        const map = markerRef.current.getMap();
        map.panTo(latLng);
        markerRef.current.setPosition(latLng);
        reverseGeocode(latLng);
        setForm((f) => ({ ...f, latitude: toFixed6(latitude), longitude: toFixed6(longitude) }));
        toast.success("Centered to your location.");
      },
      () => toast.error("Permission denied or unavailable."),
      { enableHighAccuracy: true, timeout: 8000 }
    );
  }

  function reverseGeocode(latLng) {
    geocoderRef.current.geocode({ location: latLng }, (res, status) => {
      if (status === "OK" && res && res[0]) {
        setForm((f) => ({ ...f, address: res[0].formatted_address || "" }));
      }
    });
  }

  function onChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  }

 
  function clearAll() {
    setForm({ address: "", latitude: "", longitude: "" });
    setPlaceId("");
    toast.success("Cleared fields (map unchanged).");
  }

  // function toast(msg) {
  //   // Simple Bootstrap toast substitute
  //   const el = document.createElement("div");
  //   el.className = "position-fixed bottom-0 end-0 p-3";
  //   el.style.zIndex = 1080;
  //   el.innerHTML = `
  //     <div class="toast align-items-center text-bg-dark border-0 show" role="alert">
  //       <div class="d-flex">
  //         <div class="toast-body">${msg}</div>
  //         <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
  //       </div>
  //     </div>`;
  //   document.body.appendChild(el);
  //   setTimeout(() => el.remove(), 2200);
  // }

  return (
    <>
      <Header />

      <main className="page">
       
        {loading ?  <LoadingScreen/> : 
        <div className="container pt-0">
          <div
            className="dashboard-content bg-white px-4 py-3 "
            style={{ maxWidth: "100vw" }}
          >
            <div className="card  border-0">
              <form className="m-b20 row">
                <div className="col-md-12 mt-4">
                  <h4 className="mb-2 text-uppercase"> Signup As {catData.title} </h4>

   

<ul className="customradio input-group two-grid d-none mb-4 px-0 mx-0">
                    <li>
                      <input
                        type="radio"
                        name="type"
                        onChange={handleChange}
                        value="4"
                        checked={inputs.type === "4"}
                      />
                      <label>Business partner</label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="type"
                        onChange={handleChange}
                        value="5"
                        checked={inputs.type === "5"}
                      />
                      <label>Wearehouse Channel Partner</label>
                    </li>
                    
                     <li>
                      <input
                        type="radio"
                        name="type"
                        onChange={handleChange}
                        value="6"
                        checked={inputs.type === "6"}
                      />
                      <label>Company Partner Center</label>
                    </li>
                    

                     <li>
                      <input
                        type="radio"
                        name="type"
                        onChange={handleChange}
                        value="7"
                        checked={inputs.type === "7"}
                      />
                      <label>Fund Partner</label>
                    </li>
                    


                  </ul>

                  <hr/>
 <div className="col-md-4">
{catData.logic === 1 ? <>
 {catData.multi && catData.multi.length !== 0 && (
  <>
    <label> User Type <span className="text-danger"> (Required) </span> </label>
    <div className="input-group mb-4 px-0 mx-0 mt-2">
      <select
        name="dynamic"
        className="form-select "
        onChange={handleChange}
        value={inputs.dynamic}
      >
        <option value="">Select Employee Type</option>
        {catData.multi.map((data, index) => (
          <option key={index} value={data.name}>
            {data.name}
          </option>
        ))}
      </select>
    </div>
   </>
)}
</> : <>
 {catData.multi && catData.multi.length !== 0 && (
  <>
    <label> User Type <span className="text-danger"> (Required) </span> </label>

    <div className="input-group mb-4 px-0 mx-0 mt-2">
      <select
        name="empType"
        className="form-select"
        onChange={handleChange}
        value={inputs.empType}
      >
        <option value="">Select Employee Type</option>
        {catData.multi.map((data, index) => (
          <option key={index} value={data.type}>
            {data.name}
          </option>
        ))}
      </select>
    </div>
   </>
)}
</>}


  
 </div>

                  </div>  
              
             
                <div className="col-md-6">
                  {inputs.type === "4" && 
                   <ul className="customradio input-group two-grid  mb-4 px-0 mx-0">
                     <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="0"
                        checked={inputs.empType === "0"}
                      />
                      <label>Business partner center </label>
                    </li>

                    <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="3"
                        checked={inputs.empType === "3"}
                      />
                      <label>Delivery Employees</label>
                    </li>
                    
                    
                  </ul>

                  }
                  
                </div>
                <div className="mb-4">
                  <label className="form-label text-dark" htmlFor="name">
                    Full Name <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="text"
                      id="username"
                      className="form-control"
                      name="username"
                      value={inputs.username}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-4 col-md-6">
                  <label className="form-label text-dark" htmlFor="name">
                    Phone <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="number"
                      id="phone"
                      className="form-control"
                      name="phone"
                      value={inputs.phone}
                      onChange={(e) => {
                        if (e.target.value.length <= 10) {
                          // Check input length before updating
                          handleChange(e); // Call handleChange if length is within limit
                        }
                      }}
                      onInput={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length <= 10) {
                          setInputs({ ...inputs, phone: inputValue });
                        }
                      }}
                      // onChange={() => {
                      //   handleChange();
                      // }}
                    />
                  </div>
                </div>
                <div className="mb-4 col-md-6">
                  <label className="form-label text-dark" htmlFor="email">
                    Email <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      name="email"
                      value={inputs.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-4 col-md-6">
                  <label className="form-label text-dark" htmlFor="password">
                    Password <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      className="form-control dz-password"
                      name="password"
                      value={inputs.password}
                      onChange={handleChange} // Add onChange handler to manage input changes
                      // onKeyPress={(e) => {
                      //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                      //     submitLoginPass();
                      //   }
                      // }}
                    />
                    <span className="input-group-text text-primary p-1">
                      {/* Toggle password visibility button */}
                      <i
                        className={
                          showPassword
                            ? "ri-eye-off-fill cursor"
                            : "ri-eye-fill cursor"
                        }
                        onClick={togglePasswordVisibility}
                      />
                    </span>
                  </div>
                </div>
                <div className="mb-4 col-md-6">
                  <label className="form-label text-dark" htmlFor="password">
                    Confirm Password{" "}
                    <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      className="form-control dz-password"
                      name="confirm_password"
                      value={inputs.confirm_password}
                      onChange={handleChange} // Add onChange handler to manage input changes
                      // onKeyPress={(e) => {
                      //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                      //     submitLoginPass();
                      //   }
                      // }}
                    />
                    <span className="input-group-text text-primary p-1">
                      {/* Toggle password visibility button */}
                      <i
                        className={
                          showPassword
                            ? "ri-eye-off-fill cursor"
                            : "ri-eye-fill cursor"
                        }
                        onClick={togglePasswordVisibility}
                      />
                    </span>
                  </div>
                </div>

                  <div className="mb-4 col-md-6 ">
                    <label className="form-label text-dark" htmlFor="email">
                      Gender <span className="text-danger"> ( Required )</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={inputs.gender}
                        name="gender"
                        onChange={handleChange}
                      >
                        <option selected disabled>
                          {" "}
                          Select Gender
                        </option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="0">Other</option>
                      </select>
                    </div>
                  </div>
           

                  <div className="mb-4 col-md-6  ">
                    <label className="form-label text-dark" htmlFor="email">
                      DOB <span className="text-danger"> ( Required )</span>
                    </label>
                    <div className="input-group    input-sm">
                  
                      <input
                        type="date"
                        id="DOB"
                        className="form-control custom-date"
                        name="DOB"
                        value={inputs.DOB}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
           

                <div className="mb-4 col-md-6  ">
                  <label className="form-label text-dark" htmlFor="email">
                    State <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    {/* <select
                      className="form-control"
                      id="state"
                      name="state"
                      value={inputs.state}
                      onChange={handleChange}
                    >
                      <option selected disabled>
                        {" "}
                        {loading ? "Loading..." : "Select State"}
                      </option>
                      {data.length !== 0 && data.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      ))}{" "}
                      ;
                    </select> */}


                    <Select
  options={data.map(item => ({
    value: item._id,
    label: item.name
  }))}
  placeholder={loading ? "Loading..." : "Select State"}
  isSearchable={true}
  value={data
    .map(item => ({ value: item._id, label: item.name }))
    .find(option => option.value === inputs.state) || null}
  onChange={(selectedOption) => {
    handleChange({ target: { name: "state", value: selectedOption.value } });
  }}
  className="w-100"
/>


                  </div>
                </div>

                <div className="mb-4 col-md-6 ">
                  <label className="form-label text-dark" htmlFor="city">
                    City <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    {/* <select
                      className="form-control"
                      id="city"
                      name="city"
                      value={inputs.city}
                      onChange={handleChange}
                    >
                      <option selected value={""}>
                        {" "}
                     Select City 
                      </option>
                      {Array.isArray(filteredCities) && filteredCities.length > 0 && (
  filteredCities.map((city, index) => (
    <option key={index} value={city}>
      {city}
    </option>
  ))
)}

                    </select> */}

                 
<Select
  options={Array.isArray(filteredCities)
    ? filteredCities.map((city) => ({ value: city, label: city }))
    : []}
  placeholder="Select City"
  isSearchable={true}
  value={
    Array.isArray(filteredCities)
      ? filteredCities
          .map((city) => ({ value: city, label: city }))
          .find(option => option.value === inputs.city) || null
      : null
  }
  onChange={(selectedOption) => {
    handleChange({ target: { name: "city", value: selectedOption.value } });
  }}
  className=" w-100"
/>
 </div>
                </div>

                <div className="mb-4 col-md-6 ">
         
{/* Multi Select for Coverage */}
<div className="mb-2 col-12">
     <label className="form-label text-dark" htmlFor="coverage">
       Coverage Areas <span className="text-muted">(Multi Select)</span>
     </label>
     <div className="input-group input-sm">
       {/* <select
         className="form-control"
         id="coverage"
         name="coverage"
         onChange={handleChange}
         selected={inputs.coverage}
         value={'null'}
       >
         <option value="null" selected>
           Select Coverage Area
         </option>
         {filteredCities.map((city, index) => (
           <option key={index} value={city}>
             {city}
           </option>
         ))}
       </select> */}


       <Select
  options={Array.isArray(filteredCities)
    ? filteredCities.map((city) => ({ value: city, label: city }))
    : []}
  placeholder="Select Coverage Area"
  isSearchable={true}
  value={
    Array.isArray(filteredCities)
      ? filteredCities
          .map((city) => ({ value: city, label: city }))
          .find(option => option.value === inputs.coverage) || null
      : null
  }
  onChange={(selectedOption) => {
    handleChange({ target: { name: "coverage", value: selectedOption.value } });
  }}
  className="w-100"
/>

     </div>
     </div>
     <div className="mb-4">
{Array.isArray(inputs.coverage) && inputs.coverage.length > 0 ? (
 inputs.coverage.map((city, index) => (
   <span
     key={index}
     className="badge bg-primary me-1"
     style={{ cursor: "pointer" }}
     onClick={() => removeCoverage(city)}
     title="Click to remove"
   >
     {city} ×
   </span>
 ))
) : (
 <span className="text-muted">No coverage cities selected.</span>
)}
</div>
</div>
                

                <div className="mb-4 col-md-6  ">
                  <label className="form-label text-dark" htmlFor="email">
                    Pincode <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                      type="number"
                      id="pincode"
                      className="form-control custom-date"
                      name="pincode"
                      value={inputs.pincode}
                      onChange={handleChange}
                    />
                  </div>
                </div>


                  <div className="card shadow-sm">
        <div className="row g-0">
          <div className="col-lg-4 p-2">
            <div
              ref={mapRef}
              style={{ width: "100%", height: 300, borderRadius: 8, background: "#f3f4f6" }}
            />
            {loadingMaps && (
              <div className="text-center py-3 small text-muted">Loading Google Maps…</div>
            )}
          </div>

          <div className="col-lg-8 p-3">
            <div className="mb-3">
              <label className="form-label">Search location</label>
              <div className="d-flex gap-2">
                <input
                  ref={searchInputRef}
                  type="text"
                  className="form-control"
                  placeholder="Type to search…"
                />
                <button onClick={geolocate} className="btn btn-dark" type="button">
                  Use my location
                </button>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Full Address</label>
              <textarea
                name="address"
                value={form.address}
                onChange={onChange}
                type="text"
                className="form-control"
                placeholder="Will auto-fill from pin/selection"
              />
            </div>

            <div className="row g-2 d-none">
              <div className="col-md-4">
                <label className="form-label">Latitude</label>
                <input
                  name="latitude"
                  value={form.latitude}
                  onChange={onChange}
                  type="text"
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Longitude</label>
                <input
                  name="longitude"
                  value={form.longitude}
                  onChange={onChange}
                  type="text"
                  className="form-control"
                  readOnly
                />
              </div>
           
            </div>

            <div className="d-flex gap-2 mt-3">
              {/* <button onClick={save} className="btn btn-primary" type="button">
                Save Location
              </button> */}
              <button onClick={clearAll} className="btn btn-danger" type="button">
                Clear
              </button>
            </div>

            <p className="form-text mt-3">
              • Click the map or drag the pin to set the location. <br />
              • Autocomplete search will center and fill the address. <br />
              
            </p>
          </div>
        </div>
 
      </div>


                {/* <div className="mb-4  ">
                  <label className="form-label text-dark" htmlFor="email">
                    Address <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <textarea
                      className="form-control"
                      id="address"
                      name="address"
                      onChange={handleChange}
                      rows="2"
                    >
                      {inputs.address}
                    </textarea>
                  </div>
                </div> */}

                <div className="w-auto me-auto mt-4 mb-4">
                  {!SubmitLoading ? (
                    <button
                      className="btn btn-thin btn-md w-100 btn-primary rounded-xl"
                      type="button"
                      onClick={buyNow}
                    >
                  Pay Now
                     </button>
                  ) : (
                    <button
                      disabled
                      className="btn btn-thin btn-md w-100 btn-primary rounded-xl"
                      type="button"
                    >
                      <span className="ms-1">Loading...</span>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </button>
                  )}
                </div>
               <div className="d-md-none d-block py-4">
              </div>
              </form>
            </div>
          </div>
        </div>  }
      </main>

      <Footer />
    </>
  );
};

export default SignupUserType;
